import FeedPostboxDesktop from './FeedPostboxDesktop';
import FeedPostboxContainer from './FeedPostbox.container';

export default FeedPostboxContainer(FeedPostboxDesktop);
